/**
 * Campo vazio vira `null`, que é o que o contrato espera para "sem medida".
 *
 * Recebe `unknown` de propósito: o React Hook Form chama isto também na
 * montagem, com o valor inicial — que é `null` quando a obra não tem medida.
 * Tipar como `string` e chamar `.trim()` direto derrubava a tela inteira ao
 * abrir o formulário, antes de qualquer interação.
 */
export function medidaOuNulo(valor: unknown): string | null {
  if (typeof valor !== 'string') return null;

  const limpo = valor.trim();

  return limpo === '' ? null : limpo;
}
